import { render, staticRenderFns } from "./modal-quick-view.vue?vue&type=template&id=70be6692&"
import script from "./modal-quick-view.vue?vue&type=script&lang=js&"
export * from "./modal-quick-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports